{
  "page_count": "di {n, plural, one{# pagina} other{# pagine}}"
}
